import styled from "styled-components";
import ReactTooltip from "../../ReactTooltip/ReactTooltip";

const Container = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
`;

const WhatsappBusinessIcon = () => (
  <svg
    height={20}
    width={20}
    viewBox="0 0 2500 2500"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient
        id="paint0_linear_1_12"
        x1="1264.61"
        y1="1.76e-06"
        x2="1264.61"
        y2="2500"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#61FD7D" />
        <stop offset="1" stopColor="#2BB826" />
      </linearGradient>
      <clipPath id="clip0_1_12">
        <rect width="2500" height="2500" fill="white" />
      </clipPath>
    </defs>
    <g clipPath="url(#clip0_1_12)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2514.5 1865.6C2514.5 1879.3 2514.1 1909 2513.3 1931.9C2511.3 1988 2506.8 2060.4 2500.1 2093.4C2490 2143 2474.7 2189.8 2454.8 2228.7C2431.3 2274.8 2401.2 2316 2365.5 2351.7C2329.9 2387.2 2288.7 2417.2 2242.7 2440.6C2203.6 2460.5 2156.5 2475.8 2106.6 2485.9C2073.9 2492.5 2002.1 2496.9 1946.3 2498.8C1923.3 2499.6 1893.7 2500 1880 2500L649 2499.8C635.3 2499.8 605.6 2499.4 582.7 2498.6C526.6 2496.6 454.2 2492.1 421.2 2485.4C371.6 2475.3 324.8 2460 285.9 2440.1C239.8 2416.6 198.6 2386.5 162.9 2350.8C127.4 2315.2 97.4 2274 74 2228C54 2188.8 38.8 2141.8 28.7 2091.9C22.1 2059.2 17.7 1987.4 15.8 1931.6C15 1908.6 14.6 1879 14.6 1865.3L14.8 634.3C14.8 620.6 15.2 590.9 16 568C18 511.9 22.5 439.5 29.2 406.5C39.4 357 54.7 310.3 74.6 271.3C98.1 225.2 128.2 184 163.9 148.3C199.4 112.8 240.7 82.9 286.7 59.5C325.9 39.5 372.9 24.3 422.8 14.2C455.5 7.6 527.3 3.2 583.1 1.3C606 0.4 635.7 0 649.3 0L1880.3 0.2C1894 0.2 1923.7 0.6 1946.6 1.4C2002.7 3.4 2075.1 7.9 2108.1 14.6C2157.7 24.7 2204.5 40 2243.4 59.9C2289.5 83.4 2330.7 113.5 2366.4 149.2C2401.9 184.8 2431.9 226 2455.3 272C2475.3 311.2 2490.5 358.2 2500.6 408.1C2507.2 440.8 2511.6 512.6 2513.5 568.4C2514.3 591.4 2514.7 621 2514.7 634.7L2514.5 1865.6Z"
        fill="url(#paint0_linear_1_12)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1927 591.4C1757.7 422 1532.7 328.7 1292.8 328.6C798.7 328.6 396.5 730.6 396.3 1224.7C396.2 1382.6 437.5 1536.8 516 1672.7L388.8 2137.1L864 2012.5C994.9 2083.9 1142.4 2121.5 1292.4 2121.6H1292.8C1786.9 2121.6 2189.1 1719.5 2189.3 1225.4C2189.4 986 2096.3 760.8 1927 591.4ZM1292.9 1970.3H1292.6C1158.9 1970.2 1027.8 1934.3 913.4 1866.5L886.2 1850.4L604.2 1924.4L679.5 1649.5L661.8 1621.3C587.2 1502.7 547.8 1365.6 547.9 1224.9C547.9 814.1 882.2 480 1293.2 480C1492.2 480.1 1679.3 557.7 1820 698.5C1960.7 839.3 2038.1 1026.4 2038 1225.5C2037.8 1636.1 1703.6 1970.3 1292.9 1970.3Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M992.3 1658.9C998.6 1662.7 1011.6 1662.7 1041.3 1662.7C1167.4 1662.6 1276.4 1662.2 1353.9 1662.2C1715.6 1662.2 1706.1 1281.4 1537 1233.9C1561.8 1190 1674.6 1107.6 1604.8 937.2C1535.8 768.7 1239 806.9 1035.9 807C960.8 807 972 862.5 972.4 948.8C973 1085.5 972.5 1455.5 972.4 1615.4C972.5 1647.8 982.3 1652.8 992.3 1658.9ZM1148.8 1519.3C1183 1519.3 1263.5 1519.3 1332.6 1519.2C1410.8 1519.1 1480.4 1482.5 1478.7 1404.7C1477.4 1331.4 1428.6 1307.3 1360.9 1300.6C1296.4 1301.2 1222.6 1301.2 1148.8 1301.2V1519.3ZM1148.8 1153.9C1284.9 1152 1337.3 1159.4 1411.6 1140.8C1462.6 1111.8 1484.9 1004.4 1411.9 967.9C1361.2 942.5 1211.2 951.2 1148.8 953.8V1153.9Z"
        fill="white"
      />
    </g>
  </svg>
)

const WhatsappCloudIcon = () => {
  return (
    <svg
    height={20}
    width={20}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 584 584"
  >
    <defs>
      <linearGradient
        id="whatsapp-linear-gradient"
        x1="292"
        y1="584"
        x2="292"
        y2="0"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#25cf43" />
        <stop offset="1" stopColor="#61fd7d" />
      </linearGradient>
    </defs>
    <g>
      <g id="WhatsApp_Logo_Icon">
        <g id="Icon_Shape">
          <path
            fill="url(#whatsapp-linear-gradient)"
            fillRule="evenodd"
            d="M584,435.8c0,3.2,0,10.1-.3,15.5-.5,13.1-1.5,30-3.1,37.7-2.4,11.6-5.9,22.5-10.6,31.6-5.5,10.8-12.5,20.4-20.9,28.7-8.3,8.3-17.9,15.3-28.7,20.8-9.1,4.7-20.1,8.2-31.8,10.6-7.6,1.5-24.4,2.6-37.4,3-5.4.2-12.3.3-15.5.3H148.2c-3.2,0-10.1-.1-15.5-.3-13.1-.5-30-1.5-37.7-3.1-11.6-2.4-22.5-5.9-31.6-10.6-10.8-5.5-20.4-12.5-28.7-20.9-8.3-8.3-15.3-17.9-20.8-28.7-4.7-9.1-8.2-20.1-10.6-31.8-1.5-7.6-2.6-24.4-3-37.4-.2-5.4-.3-12.3-.3-15.5V148.2c0-3.2.1-10.1.3-15.5.5-13.1,1.5-30,3.1-37.7,2.4-11.6,5.9-22.5,10.6-31.6,5.5-10.8,12.5-20.4,20.9-28.7,8.3-8.3,17.9-15.3,28.7-20.8,9.1-4.7,20.1-8.2,31.8-10.6,7.6-1.5,24.4-2.6,37.4-3,5.4-.2,12.3-.3,15.5-.3h287.6c3.2,0,10.1.1,15.5.3,13.1.5,30,1.5,37.7,3.1,11.6,2.4,22.5,5.9,31.6,10.6,10.8,5.5,20.4,12.5,28.7,20.9,8.3,8.3,15.3,17.9,20.8,28.7,4.7,9.1,8.2,20.1,10.6,31.8,1.5,7.6,2.6,24.4,3,37.4.2,5.4.3,12.3.3,15.5v287.6Z"
          />
        </g>
        <g id="WA_Logo">
          <path
            fill="#fff"
            fillRule="evenodd"
            d="M445.6,139.8c-39.3-39.3-91.6-61-147.3-61-114.8,0-208.1,93.4-208.2,208.1,0,36.7,9.6,72.5,27.8,104l-29.5,107.8,110.4-28.9c30.4,16.6,64.6,25.3,99.5,25.3h0s0,0,0,0c114.7,0,208.1-93.4,208.2-208.1,0-55.6-21.6-107.9-60.9-147.2ZM298.4,460h0c-31,0-61.5-8.4-88.1-24.1l-6.3-3.7-65.5,17.2,17.5-63.8-4.1-6.5c-17.3-27.5-26.5-59.4-26.5-92.1,0-95.4,77.7-173,173.1-173,46.2,0,89.7,18,122.3,50.7,32.7,32.7,50.7,76.2,50.6,122.4,0,95.4-77.7,173-173,173ZM393.3,330.5c-5.2-2.6-30.8-15.2-35.5-16.9-4.8-1.7-8.2-2.6-11.7,2.6-3.5,5.2-13.4,16.9-16.5,20.4-3,3.5-6.1,3.9-11.3,1.3-5.2-2.6-22-8.1-41.8-25.8-15.5-13.8-25.9-30.8-28.9-36s-.3-8,2.3-10.6c2.3-2.3,5.2-6.1,7.8-9.1,2.6-3,3.5-5.2,5.2-8.7,1.7-3.5.9-6.5-.4-9.1-1.3-2.6-11.7-28.2-16-38.6-4.2-10.1-8.5-8.8-11.7-8.9-3-.2-6.5-.2-10-.2s-9.1,1.3-13.9,6.5c-4.8,5.2-18.2,17.8-18.2,43.4s18.6,50.3,21.2,53.8c2.6,3.5,36.7,56,88.9,78.5,12.4,5.4,22.1,8.6,29.7,11,12.5,4,23.8,3.4,32.8,2.1,10-1.5,30.8-12.6,35.1-24.7,4.3-12.1,4.3-22.6,3-24.7-1.3-2.2-4.8-3.5-10-6.1Z"
          />
        </g>
      </g>
    </g>
  </svg>
  )
}

export default function ChatIndicator({ isSmbMessage, isCloudApiMessage }) {
  if(!isCloudApiMessage && !isSmbMessage) return null
  
  const tooltipId = "chat-indicator-tooltip";
  return (
    <Container>
      {isSmbMessage && (
        <div 
          style={{display: "flex", alignItems: "center", justifyContent: "center"}}
          data-tooltip-id={tooltipId}
          data-tooltip-content="Sent from the WhatsApp Business App">
          <WhatsappBusinessIcon />
        </div>
      )}  
      
      {isCloudApiMessage && (
        <div 
          style={{display: "flex", alignItems: "center", justifyContent: "center"}}
          data-tooltip-id={tooltipId}
          data-tooltip-content="Sent using the WhatsApp Cloud API">
          <WhatsappCloudIcon />
        </div>
      )}

      <ReactTooltip id={tooltipId} place="top" effect="solid" style={{padding: "8px 10px"}} />
    </Container>
  );
}
